import React from 'react';

const FAMILY_FEATURES = [
  'College planning and organization',
  'NCAA eligibility tracker',
  'Recruiting education and guidance',
  'NIL education and resources',
  'Future ready curriculum',
  'Goal setting and action plans',
  'Calendar and task management',
  'Parent & guardian access',
  'Personalized resources and learning',
] as const;

interface FamilyPlanMarketingCardProps {
  students?: number;
  onGetMoreInfo: () => void;
}

export function FamilyPlanMarketingCard({
  students = 25,
  onGetMoreInfo,
}: FamilyPlanMarketingCardProps) {
  return (
    <div className="plans-b-card plans-b-card--features" data-testid="family-plan-marketing-card">
      <div className="plans-b-card-heading">For families · up to {students} students</div>
      <p className="plans-b-sub">
        Everything your family needs to confidently navigate the student-athlete journey from high
        school through college.
      </p>
      <div className="plans-b-trail">
        {FAMILY_FEATURES.map((feature) => (
          <div className="plans-b-trail-item" key={feature}>
            {feature}
          </div>
        ))}
      </div>
      <button
        type="button"
        className="plans-b-btn plans-b-btn-primary"
        onClick={onGetMoreInfo}
        data-testid="family-get-info-btn"
      >
        Get More Info
      </button>
    </div>
  );
}

export default FamilyPlanMarketingCard;
